export default function PeoplePage() {
  return (
    <main className="tab-main untab">
      <section className="wip-section">
        <h1>Oops, I'm a People Tab in progress. Try other tabs?</h1>
      </section>
    </main>
  );
}
